import { type FC, memo, useRef } from 'react';

import { prop } from '@ipfabric/utils/fp/prop';
import { useSlidePane } from 'components/SlidePane/useSlidePane';
import { TabView } from 'components/Tabs/TabView';
import { useLocale } from 'containers/App/LocaleContext';
import { useGraphContextSelectors } from '../GraphContext';
import { showSidePanel } from '../commands/showSidePanel';
import { TopologyLayoutSettingsDevices } from './TopologyLayoutSettingsDevices/TopologyLayoutSettingsDevices';
import { TopologyLayoutSettingsProtocols } from './TopologyLayoutSettingsProtocols/TopologyLayoutSettingsProtocols';
import type { StpInstancesHook } from './TopologyLayoutSettingsProtocolsProtocol/useStpInstances';

interface Props {
  stpInstancesHook: StpInstancesHook;
}

const BareTopologyLayoutSettings: FC<Props> = (props) => {
  const msg = useLocale();
  const layoutSettingsRef = useRef<HTMLDivElement>(null);
  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
    tabId: prop('sidePanel', 'topologyLayoutSettingsTabId'),
  });

  const { openPane, closePane, pane } = useSlidePane();

  const tabs = [
    {
      key: 'protocols',
      label: msg.canvasGraph.graphSidePanel.layoutSettings.protocolsTab,

      render: () => (
        <TopologyLayoutSettingsProtocols
          closePane={closePane}
          openPane={openPane}
          stpInstancesHook={props.stpInstancesHook}
        />
      ),
    },
    {
      key: 'devices',
      label: msg.canvasGraph.graphSidePanel.layoutSettings.devicesTab,

      render: () => <TopologyLayoutSettingsDevices />,
    },
  ] as const;

  return (
    <div
      className='flex flex-1 flex-col overflow-hidden'
      ref={layoutSettingsRef}
    >
      {pane}
      <TabView
        tabs={tabs}
        activeTab={ctxProps.tabId}
        onChangeTab={(topologyLayoutSettingsTabId) => {
          ctxProps.dispatch(showSidePanel, { topologyLayoutSettingsTabId });
        }}
        stretch
        contentClassName='graph-side-panel-inner-tab py-5'
        className='tabs-underline'
        variant='legacy'
      />
    </div>
  );
};

export const TopologyLayoutSettings = memo(BareTopologyLayoutSettings);
